// extracted by mini-css-extract-plugin
module.exports = {"labelAndSelect":"ReviewsSort_labelAndSelect__g6aJw","label":"ReviewsSort_label__mIavu","select":"ReviewsSort_select__jiGKi","sticky":"ReviewsSort_sticky__CYUaD"};